/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createRandomInt } from '../../factoriesAny.js';
export var randomIntDependencies = {
  typedDependencies: typedDependencies,
  createRandomInt: createRandomInt
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesRandomInt.generated.js
// module id = 1489
// module chunks = 0